
<!--<div class="content">
  <app-todo (loadingEvent)="onLoadingEvent($event)"></app-todo>
  @if (showLoading) {
  <mat-spinner></mat-spinner>
}
</div> -->
<app-hero title="Archived Entries"
        description="Archived tolling packing list tracker entries"></app-hero>

<div class="full-table">
<div class="table-component">
    <div class="content">
    <div class="search-bar">
        <mat-icon class="search-icon">search</mat-icon>
        <input #search
                name="search-field"
                ngDefaultControl
                maxlength="150"
                value="Search">
    </div>

    <div class="filters-container">
    <mat-icon class="filter-icon">filter_list</mat-icon>
    <div class="filters">
        <div class="filter-items" *ngFor="let col of columns">
        <a>{{ col }}</a><mat-icon>keyboard_arrow_down</mat-icon>
        </div>
    </div>
    <div class="clear-text">Clear all</div>
    </div>
    
    <div class="table-wrapper">
        <table>

        <tbody>
            <tr class="header">
            <th *ngFor="let col of columns" class="header-col">
                {{ col }}
            </th>
            </tr>
            <tr *ngFor="let row of data" class="data">
            <td *ngFor="let col of columns" class="data-col">
                <a *ngIf="!(col == 'Attachments') && 
                    !(col == 'Distinct PL Reference') && 
                    !((col == 'Actual PL Notice Days') && (getRow(row, col) == '0')) &&
                    !(col == 'Issues')">{{ getRow(row, col)}}</a>

                <!-- Columnas especiales -->
                <span *ngIf="(col == 'Attachments')" class="material-symbols-outlined file-save-icon" (click)="downloadFile()">file_save</span>
                <span *ngIf="(col == 'Distinct PL Reference') && (getRow(row, col) == 'Yes')" class="material-symbols-outlined">check</span>
                <span *ngIf="(col == 'Distinct PL Reference') && (getRow(row, col) == 'No')" class="material-symbols-outlined">close</span>
                <a *ngIf="(col == 'Actual PL Notice Days') && getRow(row, col) == '0'" class="notice-days-data">{{ getRow(row, col) }}</a>
                <a *ngIf="(col == 'Issues') && getRow(row, col) == 'Yes'" class="issues-yes">{{ getRow(row, col) }}</a>
                <a *ngIf="(col == 'Issues') && getRow(row, col) == 'No'" class="issues-no">{{ getRow(row, col) }}</a>
            </td>
            </tr>
        </tbody>
        </table>
    </div>

    <app-paginator 
        [resultsLength]="resultsLength" 
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        (pageChange)="onPageChange($event)">
    </app-paginator>
    </div>
</div>
</div>

<ng-template #editDialogTemplate
            let-data="data">
<div class="dialog">
<div class="title">
    <a>Edit Packing List Entry</a>
    <mat-icon mat-dialog-close>close</mat-icon>
</div>
<mat-dialog-content>

    <div class="dialog-content">

    <div class="dialog-item-section">
    <a class="dialog-item-legend">General Information</a>
        <div class="dialog-item">
        <a>Site: </a>
        <input #site
                name="site-input"
                ngDefaultControl
                maxlength="150"
                [(ngModel)]="selected.Site">
        </div>
        <div class="dialog-item">
        <a>Customer: </a>
        <input #customer
                name="customer-input"
                ngDefaultControl
                maxlength="150"
                [(ngModel)]="selected.Customer">
        </div>
        <div class="dialog-item-radio">
        <a>Toll Principal: </a>
        <div class="radio-options">
            <input type="radio" class="custom-radio" id="uk" name="tollPrincipal" value="UK" [(ngModel)]="selected.TollPrincipal"/>
            <label for="toll-uk">UK</label>
        </div>
        <div class="radio-options">
            <input type="radio" class="custom-radio" id="sweden" name="tollPrincipal" value="Sweden" [(ngModel)]="selected.TollPrincipal"/>
            <label for="toll-sweden">Sweden</label>
        </div>
        
        </div>
    </div>

    <div class="dialog-item-section">
    <a class="dialog-item-legend">Packing List Details</a>
        <div class="dialog-item">
        <a>PL Reference Number: </a>
        <input #plNumber
                name="pl-number-input"
                ngDefaultControl
                maxlength="150"
                [(ngModel)]="selected.PackingListReferenceNumber">
        </div>
        <div class="dialog-item-radio">
        <a>Distinct PL Reference: </a>
        <div class="dialog-radios">
        <div class="radio-options">
            <input type="radio" class="custom-radio" id="distinctPLYes" name="distinctPLYes" value="Yes" [(ngModel)]="selected.DistinctPLReference"/>
            <label for="distinctPLYes">Yes</label>
        </div>
        <div class="radio-options">
            <input type="radio" class="custom-radio" id="distinctPLNo" name="distinctPLNo" value="No" [(ngModel)]="selected.DistinctPLReference" />
            <label for="distinctPLNo">No</label>
        </div>
        </div>
        </div>
        <div class="dialog-item">
        <a>Target Packing List Notice: </a>
        <input #targetPlNotice
                name="target-pl-notice-input"
                ngDefaultControl
                maxlength="150"
                value="{{selected.TargetPLNoticeDays}} days" disabled class="disabled">
        </div>
        <div class="dialog-item">
        <a>Actual PL Reference: </a>
        <input #actualPlNotice
                name="actual-pl-notice-input"
                ngDefaultControl
                maxlength="150"
                value="{{selected.ActualPLNoticeDays}} days" disabled class="disabled">
        </div>
    </div>

    <div class="dialog-item-section">
    <a class="dialog-item-legend">Dates</a>
        <div class="dialog-item date">
        <a>Date Received: </a>
        <input type="date"
                id="dateReceived"
                name="dateReceived"
                [(ngModel)]="selected.DateReceived" />
        </div>

        <div class="dialog-item date">
        <a>Despatch Date: </a>
        <input type="date"
                id="despatchDate"
                name="despatchDate"
                [(ngModel)]="selected.DespatchDate" />
        </div>
    </div>

    <div class="dialog-item-section">
    <a class="dialog-item-legend">Attachments</a>
        <div class="dialog-item">
        <a>AZ Commercial Invoice: </a>
        <input #azCommercialInvoice
                name="azCommercialInvoice-input"
                ngDefaultControl
                maxlength="150"
                [(ngModel)]="selected.AZCommercialInvoice">
        </div>
        <div class="dialog-item">
        <a>Attachments: </a>
        <input #attachments
                name="attachments-input"
                ngDefaultControl
                maxlength="150"
                [(ngModel)]="selected.Attachments">
        </div>
    </div>

    <div class="dialog-item-section">
    <a class="dialog-item-legend">Issues</a>
    <div class="dialog-item-radio">
        <a>Were there any issues? </a>
        <div class="radio-options">
        <input type="radio" class="custom-radio" id="yes" name="yes" value="Yes" [(ngModel)]="selected.Issues"/>
        <label for="toll-yes">Yes</label>
        </div>
        <div class="radio-options">
        <input type="radio" class="custom-radio" id="no" name="no" value="No" [(ngModel)]="selected.Issues" />
        <label for="toll-no">No</label>
        </div>
    </div>

        <div class="dialog-item">
        <a>Issue Type: </a>
        <input #issueType
                name="issueType-input"
                ngDefaultControl
                maxlength="150"
                [(ngModel)]="selected.IssueType">
        </div>
        <div class="dialog-item">
        <a>Who: </a>
        <input #who
                name="who-input"
                ngDefaultControl
                maxlength="150"
                [(ngModel)]="selected.Who">
        </div>
        <div class="dialog-item">
        <a>Narrative: </a>
        <input #narrative
                name="narrative-input"
                ngDefaultControl
                maxlength="500"
                [(ngModel)]="selected.Narrative">
        </div>
    </div>

</div>

</mat-dialog-content>
<div class="dialog-footer">
    <a>Account Details last edited by: Gonzalez, Laura on 15/04/2025 at 11:34 AM CST</a>
    <div class="dialog-buttons">
    <button class="cancel" mat-dialog-close>Cancel</button>
    <button class="save" (click)="saveChanges()">Save</button>
    </div>
</div>
</div>
</ng-template>

<ng-template #addDialogTemplate
            let-data="data">
<div class="dialog">
<div class="title">
    <a>Add New Packing List Entry</a>
    <mat-icon mat-dialog-close>close</mat-icon>
</div>
<mat-dialog-content>

    <div class="dialog-content">

    <div class="dialog-item-section">
    <a class="dialog-item-legend">General Information</a>
        <div class="dialog-item">
        <a>Site: </a>
        <input #site
                name="site-input"
                ngDefaultControl
                maxlength="150"
                placeholder="Site">
        </div>
        <div class="dialog-item">
        <a>Customer: </a>
        <input #customer
                name="customer-input"
                ngDefaultControl
                maxlength="150"
                placeholder="Customer">
        </div>
        <div class="dialog-item-radio">
        <a>Toll Principal: </a>
        <div class="radio-options">
            <input type="radio" class="custom-radio" id="uk" name="uk" value="uk"/>
            <label for="toll-uk">UK</label>
        </div>
        <div class="radio-options">
            <input type="radio" class="custom-radio" id="sweden" name="sweden" value="sweden" />
            <label for="toll-sweden">Sweden</label>
        </div>
        
        </div>
    </div>

    <div class="dialog-item-section">
    <a class="dialog-item-legend">Packing List Details</a>
        <div class="dialog-item">
        <a>PL Reference Number: </a>
        <input #plNumber
                name="pl-number-input"
                ngDefaultControl
                maxlength="150"
                placeholder="PL Reference Number">
        </div>
        <div class="dialog-item-radio">
        <a>Distinct PL Reference: </a>
        <div class="dialog-radios">
        <div class="radio-options">
            <input type="radio" class="custom-radio" id="distinctPLYes" name="distinctPLYes" value="distinctPLYes"/>
            <label for="distinctPLYes">Yes</label>
        </div>
        <div class="radio-options">
            <input type="radio" class="custom-radio" id="distinctPLNo" name="distinctPLNo" value="distinctPLNo" />
            <label for="distinctPLNo">No</label>
        </div>
        </div>
        </div>
        <div class="dialog-item">
        <a>Target Packing List Notice: </a>
        <input #targetPlNotice
                name="target-pl-notice-input"
                ngDefaultControl
                maxlength="150"
                placeholder="Target Packing List Notice">
        </div>
        <div class="dialog-item">
        <a>Actual PL Reference: </a>
        <input #actualPlNotice
                name="actual-pl-notice-input"
                ngDefaultControl
                maxlength="150"
                placeholder="Actual PL Reference">
        </div>
    </div>

    <div class="dialog-item-section">
    <a class="dialog-item-legend">Dates</a>
        <div class="dialog-item date">
        <a>Date Received: </a>
        <input type="date"
                id="dateReceived"
                name="dateReceived"
                placeholder="Date Received" />
        </div>

        <div class="dialog-item date">
        <a>Despatch Date: </a>
        <input type="date"
                id="despatchDate"
                name="despatchDate"
                placeholder="Despatch Date" />
        </div>
    </div>

    <div class="dialog-item-section">
    <a class="dialog-item-legend">Attachments</a>
        <div class="dialog-item">
        <a>AZ Commercial Invoice: </a>
        <input #azCommercialInvoice
                name="azCommercialInvoice-input"
                ngDefaultControl
                maxlength="150"
                placeholder="AZ Commercial Invoice">
        </div>
        <div class="dialog-item">
        <a>Attachments: </a>
        <input #attachments
                name="attachments-input"
                ngDefaultControl
                maxlength="150"
                placeholder="Attachments">
        </div>
    </div>

    <div class="dialog-item-section">
    <a class="dialog-item-legend">Issues</a>
    <div class="dialog-item-radio">
        <a>Were there any issues? </a>
        <div class="radio-options">
        <input type="radio" class="custom-radio" id="yes" name="yes" value="yes"/>
        <label for="toll-yes">Yes</label>
        </div>
        <div class="radio-options">
        <input type="radio" class="custom-radio" id="no" name="no" value="no" />
        <label for="toll-no">No</label>
        </div>
    </div>

        <div class="dialog-item">
        <a>Issue Type: </a>
        <input #issueType
                name="issueType-input"
                ngDefaultControl
                maxlength="150"
                placeholder="Issue Type">
        </div>
        <div class="dialog-item">
        <a>Who: </a>
        <input #who
                name="who-input"
                ngDefaultControl
                maxlength="150"
                placeholder="Who">
        </div>
        <div class="dialog-item">
        <a>Narrative: </a>
        <input #narrative
                name="narrative-input"
                ngDefaultControl
                maxlength="500"
                placeholder="Narrative">
        </div>
    </div>

</div>

</mat-dialog-content>
<div class="dialog-footer" style="justify-content: end;">
    <div class="dialog-buttons">
    <button class="cancel" mat-dialog-close>Cancel</button>
    <button class="save">Save</button>
    </div>
</div>
</div>
</ng-template>
  
